"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _parseISO = _interopRequireDefault(require("date-fns/parseISO"));

var _startOfMonth = _interopRequireDefault(require("date-fns/startOfMonth"));

var _endOfMonth = _interopRequireDefault(require("date-fns/endOfMonth"));

var _noop = _interopRequireDefault(require("lodash/noop"));

var _uniqueId = _interopRequireDefault(require("lodash/uniqueId"));

var _emotion = require("emotion");

var _datePickerPopover = _interopRequireDefault(require("./date-picker-popover"));

var _datePickerPresets = _interopRequireDefault(require("./date-picker-presets"));

var _dateInputField = _interopRequireDefault(require("../date-input-field"));

var _dateInputCalendar = _interopRequireDefault(require("../_date-input-calendar"));

var _supportTextWrapper = _interopRequireDefault(require("../_support-text-wrapper"));

var _dateString = require("./../_utils/date-string");

var _dateLocales = _interopRequireDefault(require("./../_utils/date-locales"));

var _getSupportTextAriaDescribedby = _interopRequireDefault(require("./../_utils/get-support-text-aria-describedby"));

var _functional = require("./../_utils/functional");

var _filterPropsByPrefix = _interopRequireDefault(require("./../_utils/filter-props-by-prefix"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var widthStyles = (0, _functional.memoizeByKeys)(function (_ref) {
  var width = _ref.width;
  return (0, _emotion.css)({
    width: width,
    // If an explicit width is set then don't allow the textarea to flex
    flex: width ? "none !important" : undefined
  });
}, ["width"]);
/**
 * A form control for selecting dates. Uses the Input, DateInputCalendar, and
 * PopoverController components to create a nice interface for quickly selecting
 * a single date.
 */

var DatePicker = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var onChange = props.onChange,
      defaultViewDate = props.defaultViewDate,
      value = props.value,
      now = props.now,
      popoverIdProp = props.popoverId,
      idProp = props.id;
  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "aria-"]);
  var popoverId = (0, _react.useMemo)(function () {
    return popoverIdProp ? popoverIdProp : (0, _uniqueId["default"])("datepicker-popover-");
  }, [popoverIdProp]);
  var id = (0, _react.useMemo)(function () {
    return idProp || (0, _uniqueId["default"])("datepicker-");
  }, [idProp]);
  /**
   * Return the date that the calendar popup should be initialized to show. If
   * a view date was explicitly set via props then use that, otherwise use the
   * selected date if there is a valid one, otherwise fallback to the current
   * date.
   */

  var getCalendarViewDate = (0, _react.useCallback)(function () {
    return defaultViewDate || (0, _dateString.parseDateString)(value) && value || now;
  }, [defaultViewDate, value, now]);

  var _useState = (0, _react.useState)(getCalendarViewDate()),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      calendarViewDate = _useState2[0],
      setCalendarViewDate = _useState2[1];
  /**
   * Change the months shown by the calendar picker to include a given date.
   * This handler ignores empty dates and doesn't do anything if the provided
   * date is already visible in the calendar picker.
   */


  var onChangeCalendarViewDate = (0, _react.useCallback)(function (date) {
    var parsedCalendarViewDate = (0, _parseISO["default"])(calendarViewDate);
    var firstDate = (0, _dateString.toDateString)((0, _startOfMonth["default"])(parsedCalendarViewDate));
    var lastDate = (0, _dateString.toDateString)((0, _endOfMonth["default"])(parsedCalendarViewDate));

    if (date && !(0, _dateString.isWithinRange)(date, firstDate, lastDate)) {
      setCalendarViewDate(date);
    }
  }, [calendarViewDate]);
  var onChangeField = (0, _react.useCallback)(function (value) {
    onChange(value); // Update the view to ensure that the new date is visible

    onChangeCalendarViewDate(value);
  }, [onChange, onChangeCalendarViewDate]);
  /**
   * Before opening the popover, make sure that the view date is correct (in
   * case the selected date was changed since the last time the popover was
   * opened or the user messed with the view date before previously closing the
   * popover).
   */

  var onBeforeOpenPopover = (0, _react.useCallback)(function () {
    return onChangeCalendarViewDate(getCalendarViewDate());
  }, [onChangeCalendarViewDate, getCalendarViewDate]); // If there is not helperText, constraintText, or errorMessage
  // then the aria-describedby is empty.

  var ariaDescribedbyValue = (0, _getSupportTextAriaDescribedby["default"])({
    id: id,
    hasHelperText: !!props.helperText,
    hasConstraintText: !!props.constraintText,
    hasErrorMessage: !!props.errorMessage,
    errorMessageFirst: props.size === "xlarge"
  });
  return /*#__PURE__*/_react["default"].createElement(_supportTextWrapper["default"], {
    id: id,
    helperText: props.helperText,
    constraintText: props.constraintText,
    errorMessage: props.errorMessage,
    label: props.label,
    className: widthStyles({
      width: props.width
    }),
    disabled: props.disabled,
    size: props.size
  }, /*#__PURE__*/_react["default"].createElement(_datePickerPopover["default"], {
    valueFilled: Boolean(props.value),
    disabled: props.disabled,
    onBlur: props.onBlur,
    onFocus: props.onFocus,
    id: popoverId,
    anchor: function anchor(_ref2) {
      var onFocus = _ref2.onFocus,
          onBlur = _ref2.onBlur,
          popoverIsOpen = _ref2.popoverIsOpen;
      return /*#__PURE__*/_react["default"].createElement(_dateInputField["default"], (0, _extends2["default"])({
        size: props.size,
        value: props.value,
        onChange: onChangeField,
        focus: popoverIsOpen ? true : undefined,
        disabled: props.disabled,
        disabledDates: props.disabledDates,
        label: props.size === "xlarge" ? props.label : undefined,
        placeholder: props.placeholder,
        onFocus: onFocus,
        onBlur: onBlur,
        invalidInputMessage: props.invalidInputMessage,
        error: props.error,
        locale: props.locale,
        inaccessibleAutoFocus: props.inaccessibleAutoFocus,
        autoFill: false,
        ref: ref,
        clearButton: props.clearButton,
        clearButtonLabel: props.clearButtonLabel,
        onClear: props.onClear,
        id: id
      }, passThroughProps, {
        "aria-describedby": ariaDescribedbyValue
      }));
    },
    onBeforeOpen: onBeforeOpenPopover
  }, function (_ref3) {
    var t = _ref3.t,
        popoverIsOpen = _ref3.popoverIsOpen,
        closePopover = _ref3.closePopover;
    return [/*#__PURE__*/_react["default"].createElement(_dateInputCalendar["default"], {
      key: "calendar",
      locale: props.locale,
      disabledDates: props.disabledDates,
      value: props.value,
      onChange: function onChange(value) {
        props.onChange(value);
        closePopover();
      },
      viewDate: calendarViewDate,
      onChangeViewDate: onChangeCalendarViewDate,
      now: props.now,
      monthsInView: props.monthsInView,
      monthWidth: props.monthWidth,
      previousMonthLabel: props.previousMonthLabel,
      nextMonthLabel: props.nextMonthLabel,
      renderDate: props.renderDate,
      dateLabel: props.dateLabel,
      animateMonthChange: popoverIsOpen
    }), props.presets.length > 0 ? /*#__PURE__*/_react["default"].createElement(_datePickerPresets["default"], {
      key: "presets",
      t: t,
      presets: props.presets,
      label: props.presetsLabel,
      onChange: function onChange(value) {
        props.onChange(value);
        closePopover();
      },
      disabledDates: props.disabledDates
    }) : null];
  }));
});

DatePicker.displayName = "DatePicker";
DatePicker.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Called any time the user enters a full, valid, enabled date into the date
   * picker. The new date will be provided to the function as a date string
   * in the format YYYY-MM-DD.
   *
   * Meridian uses [controlled components](https://reactjs.org/docs/forms.html#controlled-components),
   * so you must track the values provided to this function somewhere in state
   * and pass them back via the `value` prop in order to make this component
   * interactive.
   */
  onChange: _propTypes["default"].func.isRequired,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * Within the DatePicker component, there are some aria- attributes that we set for ourselves,
   * in order to make sure the component is wired up in a way that makes it accessible
   * right out of the box. If you attempt to override the following property,
   * they'll be ignored:
   *
   * aria-describedby
   */
  "aria-*": _propTypes["default"].string,

  /**
   * Appends a button to the input that the user can click to clear the input.
   * This will trigger the `onChange` callback with a value of `""`.
   */
  clearButton: _propTypes["default"].bool,

  /**
   * An accessible label for the clear button. This will not be visible in the UI, but
   * will be read by screen readers.
   */
  clearButtonLabel: _propTypes["default"].string,

  /**
   * Add constraint text to provide critical information regarding content.
   */
  constraintText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   */
  "data-*": _propTypes["default"].string,

  /**
   * A function that can be used to construct a screen-reader label for a particular
   * day. The function will be passed an object with the following properties.
   *
   * `date`: `string` of date in the format YYYY-MM-DD
   *
   * `label`: `string` of the localized day of the month (e.g. "Thursday, Nov 22, 2018")
   *
   * `current`: `boolean` set to `true` if the date is today's date
   *
   * `selected`: `boolean` set to `true` if date is selected
   *
   * `disabled`: `boolean` set to `true` if date is disabled
   *
   * `range`: `boolean` set to `true` if date is in the range of selected dates
   */
  dateLabel: _propTypes["default"].func,

  /**
   * This date is used to determine which month the calendar should display
   * by default. The date must be provided in the format YYYY-MM-DD. If not
   * provided then the calendar will display the month of `value`, or
   * `now` if no value is provided.
   */
  defaultViewDate: _propTypes["default"].string,

  /**
   * Determines if the entire date picker is disabled. If you want to disable
   * specific dates then use the `disabledDates` prop.
   */
  disabled: _propTypes["default"].bool,

  /**
   * A function that can be used to disable specific dates. The function will
   * be passed date strings in the format YYYY-MM-DD and is expected to return
   * true for disabled dates and false otherwise.
   */
  disabledDates: _propTypes["default"].func,

  /**
   * Show the component in an error state. Use this to indicate that the value
   * of the component is invalid.
   *
   * Consider pairing this state with an `errorMessage`.
   */
  error: _propTypes["default"].bool,

  /**
   * An explanation for why the error state has occurred.
   * This will show as an xsmall [Alert](https://meridian.a2z.com/components/alert/) below the DatePicker.
   */
  errorMessage: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /**
   * Add helper text to provide additional instruction.
   */
  helperText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /**
   * Sets an `id` attribute on the component.
   *
   * Use this for testing or for accessibility. Do not use this in order to apply override styles
   * to the component. The markup and styles rendered by Meridian components
   * are private APIs, and may change without notice.
   */
  id: _propTypes["default"].string,

  /**
   * If set to true then the input will grab focus as soon as it's mounted.
   *
   * This uses HTML's native `autofocus` attribute. Use this sparingly as
   * there are [common accessibility pitfalls](https://www.brucelawson.co.uk/2009/the-accessibility-of-html-5-autofocus/)
   * associated with this behavior.
   */
  inaccessibleAutoFocus: _propTypes["default"].bool,

  /**
   * A function that returns a message for invalid or disabled dates.
   * The function must return a localized string. The string will be displayed
   * to the user to help guide them.
   *
   * Two arguments will be passed to the function. The first argument will be an error code - either
   * "INVALID_DATE" if the user's date doesn't exist (e.g. 2018-40-40) or
   * "DISABLED_DATE" if the user's date has been disabled via the
   * `disabledDates` prop. The second argument will be the date entered by the
   * user in the format YYYY-MM-DD. This argument will only be provided for
   * the "DISABLED_DATE" error code (the "INVALID_DATE" code means we couldn't
   * actually construct a date).
   */
  invalidInputMessage: _propTypes["default"].func,

  /**
   * The label for the date input field.
   *
   * __Note__: Setting a label will effectively hide the `placeholder` value.
   */
  label: _propTypes["default"].string,

  /**
   * The locale to use when rendering the component (e.g. month names, names of
   * days of the week, etc.). See the [Intl API](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl).
   */
  locale: _propTypes["default"].oneOf(Object.keys(_dateLocales["default"])),

  /**
   * Set the width of a single month.
   */
  monthWidth: _propTypes["default"].number,

  /**
   * The number of calendar months to display at a time.
   */
  monthsInView: _propTypes["default"].number,

  /**
   * A localized label for the next month button.
   */
  nextMonthLabel: _propTypes["default"].string,

  /**
   * Define today's date (in the format YYYY-MM-DD). This date will be
   * marked in the calendar with a special indicator.
   */
  now: _propTypes["default"].string,

  /**
   * Text that is shown in place of the input's value when the input is empty.
   *
   * This text is not visible when a value is entered in the input, so it should
   * not contain essential information that should be persisted. For that,
   * consider using the `label` prop.
   *
   * __Note__: Placeholder will not appear if `label` is defined.
   */
  placeholder: _propTypes["default"].string,

  /**
   * Sets an `id` attribute on the popover container.
   *
   * Use this for testing or for accessibility. Do not use this in order to apply override styles
   * to the component. The markup and styles rendered by Meridian components
   * are private APIs, and may change without notice.
   */
  popoverId: _propTypes["default"].string,

  /**
   * A list of presets to allow quick selection of common dates.
   *
   * If provided, these presets will be shown as buttons in the date picker's
   * calendar popover.
   */
  presets: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _propTypes["default"].string,
    value: _propTypes["default"].string
  })),

  /**
   * A localized label to be shown above the list of presets.
   */
  presetsLabel: _propTypes["default"].string,

  /**
   * A localized label for the previous month button.
   */
  previousMonthLabel: _propTypes["default"].string,

  /**
   * A function that can be used to customize the rendering of a single day. The
   * function is passed an object which contains the following props.
   *
   * `date`: `string` of date in the format YYYY-MM-DD
   *
   * `label`: `string` of the localized day of the month (e.g. "21")
   *
   * `current`: `boolean` set to `true` if the date is today's date
   *
   * `selected`: `boolean` set to `true` if date is selected
   *
   * `disabled`: `boolean` set to `true` if date is disabled
   *
   * `range`: `boolean` set to `true` if date is in the range of selected dates
   */
  renderDate: _propTypes["default"].func,

  /**
   * Sets the size of the component using a preset.
   */
  size: _propTypes["default"].oneOf(["small", "medium", "large", "xlarge"]),

  /**
   * The currently selected date as formatted as a YYYY-MM-DD date string.
   *
   * Update this when `onChange` is called to ensure the component is interactive
   * (see the documentation for the `onChange` prop).
   */
  value: _propTypes["default"].string,

  /**
   * Set the width of the component using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * This is called when the entire component (input + popover calendar) loses focus.
   * The [blur event](https://developer.mozilla.org/en-US/docs/Web/API/Element/blur_event) is passed as the first argument to the function.
   */
  onBlur: _propTypes["default"].func,

  /**
   * This is called when the clear button is clicked (be sure to set `clearButton`
   * to `true`). No arguments are passed to this callback.
   */
  onClear: _propTypes["default"].func,

  /**
   * This is called when the entire component (input + popover calendar) gains focus.
   * The [focus event](https://developer.mozilla.org/en-US/docs/Web/API/Element/focus_event) is passed as the first argument to the function.
   */
  onFocus: _propTypes["default"].func
} : {};
DatePicker.defaultProps = {
  locale: "en-US",
  disabledDates: _noop["default"],
  now: (0, _dateString.toDateString)(new Date()),
  presets: [],
  size: "medium",
  invalidInputMessage: function invalidInputMessage(code) {
    return {
      INVALID_DATE: "This value is not a valid date.",
      DISABLED_DATE: "This date is not available."
    }[code];
  },
  error: false
};
var _default = DatePicker;
exports["default"] = _default;